export default __webpack_public_path__ + "static/media/img-slider-tspace-4.133d64d4.png";